export const normalizarActividad = (actividad) => {
  const nombre = String(actividad || '').trim();
  return nombre || 'Sin actividad';
};

export const agruparVisitasPorActividad = (visitas) => (
  Object.values((visitas || []).reduce((acc, visita) => {
    const actividad = normalizarActividad(visita?.tipo_actividad);
    if (!acc[actividad]) acc[actividad] = { actividad, total: 0 };
    acc[actividad].total += 1;
    return acc;
  }, {})).sort((a, b) => (b.total - a.total) || a.actividad.localeCompare(b.actividad))
);

export const totalDistribucionActividades = (distribucion) => (
  (distribucion || []).reduce((total, actividad) => total + actividad.total, 0)
);

export const resumirDistribucionActividades = (distribucion, limite = 6) => {
  const completa = distribucion || [];
  const principales = completa.slice(0, limite);
  const restantes = completa.slice(limite);
  if (!restantes.length) {
    return { actividades: principales, tiposAgrupados: 0 };
  }

  return {
    actividades: [
      ...principales,
      {
        actividad: `Otras actividades (${restantes.length} tipos)`,
        total: totalDistribucionActividades(restantes),
        agrupada: true,
      },
    ],
    tiposAgrupados: restantes.length,
  };
};
